import http from 'common-module/src/util/http';

/**
 * 获取组织 options
 * @returns {Promise<*>}
 */
export const getOrgInfo = async (data) => {
  const result = await http.post('/org-user/query-org-info', data);
  return { result };
};

/**
 * 下载模板
 * @returns {Promise<*>}
 */
export const downloadTemplate = async () => {
  const result = await http.post('issue-excel/export-member-template', {}, {
    responseType: 'blob',
    assertResult: (response, data) => {
      response.data = { result: data };
      console.log(response, data);
      return true;
    }
  });
  return result;
};

/**
 * 导出失败人员
 * @returns {Promise<*>}
 */
export const exportMemberFails = async (data) => {
  const result = await http.post('issue-excel/export-member-fails', data, {
    responseType: 'blob',
    assertResult: (response, data) => {
      response.data = { result: data };
      console.log(response, data);
      return true;
    }
  });
  return { result };
};

/**
 * 导入数据，添加成员
 * @returns {Promise<*>}
 */
export const addMemberData = async (data) => {
  const result = await http.post('org-user/import-member-data', data);
  return { result };
};

/**
 * 上传数据
 * @returns {Promise<*>}
 */
export const importMemberTemplate = async (data) => {
  const result = await http.post('/org-user/import-member-template', data, { transformRequest: null });
  return { result };
};

/**
 * 校验成员数据
 * @returns {Promise<*>}
 */
export const checkMemberData = async (data) => {
  const result = await http.post('/org-user/check-member-data', data);
  return { result };
};
